import React, { memo } from "react";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";

const Wrapper = styled(Box)(({ theme }) => ({
  width: "375px",
  padding: "17px 20px 72px",
  position: "absolute",
  top: "30px",
  zIndex: 50,
  right: "-150px",
  background: "#ffffff",
  textAlign: "left",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
  borderRadius: "10px",
  boxSizing: "border-box",
  [theme.breakpoints.up("sm")]: {
    width: "264px",
    padding: "17px 20px",
    left: "200px",
    top: "-20px",
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "16px",
  lineHeight: 1.5,
  marginBottom: "8.5px",
  color: "#1a1a1a",
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
    lineHeight: 1.5,
    marginBottom: "13px",
  },
}));

const PriceList = styled(List)(() => ({
  padding: 0,
  boxSizing: "border-box",
}));

const PriceListItem = styled(ListItem)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: " 12px 0",
  boxSizing: "border-box",
  "&:not(:last-child)": { borderBottom: "1px solid rgba(0, 0, 0, 0.1)" },
  [theme.breakpoints.up("sm")]: {
    padding: "5px 0",
  },
}));

const PriceStat = styled(Typography)(({ theme }) => ({
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.5,
  color: "#1a1a1a",
  "&.bold": {
    fontWeight: "bold",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
  },
}));

const PriceInfo = memo(
  ({
    durationCost,
    total,
    priceAdult,
    priceChild,
    priceInfant,
    totalPrice,
  }) => {
    return (
      <Wrapper>
        <Title>Price breakdown</Title>
        <PriceList>
          <PriceListItem>
            <PriceStat>Fixed fee:</PriceStat>
            <PriceStat>
              €{Number(Math.ceil( Number(durationCost)))}
            </PriceStat>
          </PriceListItem>
          {total.adults > 0 && (
            <PriceListItem>
              <PriceStat> Tickets ({total.adults} adults):</PriceStat>
              <PriceStat>
                €{Number(Number(priceAdult).toFixed(0)) * total.adults}
              </PriceStat>
            </PriceListItem>
          )}
          {total.children > 0 && (
            <PriceListItem>
              <PriceStat>Tickets ({total.children} child):</PriceStat>
              <PriceStat>
                €{Number(Number(priceChild).toFixed(0)) * total.children}
              </PriceStat>
            </PriceListItem>
          )}
          {total.infants > 0 && (
            <PriceListItem>
              <PriceStat>Tickets ({total.infants} infants):</PriceStat>
              <PriceStat>
                €{Number(Number(priceInfant).toFixed(0)) * total.infants}
              </PriceStat>
            </PriceListItem>
          )}
          <PriceListItem>
            <PriceStat className="bold">Total:</PriceStat>
            <PriceStat className="bold">€{Math.ceil(totalPrice)}</PriceStat>
          </PriceListItem>
        </PriceList>
      </Wrapper>
    );
  }
);

export default PriceInfo;
